var _toConsumableArray = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");

var _regeneratorRuntime = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var https = require('https');

var http = require('http');

var Timer = require('./Timer');

var ApiError = require('./ApiError');

var DEFAULT_SPEEDTEST_TIMEOUT = 5000; // ms

var DEFAULT_URL_COUNT = 5;
var DEFAULT_BUFFER_SIZE = 8;
var MAX_CHECK_INTERVAL = 200; // ms

var Api = /*#__PURE__*/function () {
  "use strict";

  /**
   * Create an Api object
   *
   * @param {object} options {token<string>, [verbose<boolean>, timeout<number>,
   * https<boolean>, urlCount<number>, bufferSize<number>, unit<function>]}
   */
  function Api(options) {
    _classCallCheck(this, Api);

    if (!options) {
      throw new Error('You must define options in Api constructor');
    }

    if (!options.token) {
      throw new Error('You must define app token');
    }

    if (options.unit && typeof options.unit !== 'function') {
      throw new Error('Invalid unit');
    }

    this.token = options.token;
    this.verbose = options.verbose || false;
    this.timeout = options.timeout || DEFAULT_SPEEDTEST_TIMEOUT;
    this.https = options.https == null ? true : Boolean(options.https);
    this.urlCount = options.urlCount || DEFAULT_URL_COUNT;
    this.bufferSize = options.bufferSize || DEFAULT_BUFFER_SIZE;
    this.unit = options.unit || Api.UNITS.Bps;
  }
  /**
   * Compute average from array of number
   *
   * @static
   * @param {Array} arr array of number or null
   * @return {number} The average
   */


  _createClass(Api, [{
    key: "get",

    /**
     * Get data from the specified URL
     *
     * @async
     * @param {string} url The URL to download from
     * @return {Promise} The request and response from the URL
     */
    value: function () {
      var _get = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(url) {
        var _this = this;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt("return", new Promise(function (resolve, reject) {
                  var request = (_this.https ? https : http).get(url, function (response) {
                    if (response.headers['content-type'].includes('json')) {
                      response.setEncoding('utf8');
                      var rawData = '';
                      response.on('data', function (chunk) {
                        rawData += chunk;
                      });
                      response.on('end', function () {
                        var parsedData = JSON.parse(rawData);
                        response.data = parsedData;
                        resolve({
                          response: response,
                          request: request
                        });
                      });
                    } else {
                      resolve({
                        response: response,
                        request: request
                      });
                    }
                  }).on('error', function (e) {
                    reject(e);
                  });
                }));

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function get(_x) {
        return _get.apply(this, arguments);
      }

      return get;
    }()
    /**
     * Get videos to download url from Fast api
     *
     * @async
     * @return {Array<string>} List of videos url
     */

  }, {
    key: "getTargets",
    value: function () {
      var _getTargets = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var targets, _yield$this$get, response;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                targets = [];

              case 2:
                if (!(targets.length < this.urlCount)) {
                  _context2.next = 14;
                  break;
                }

                _context2.next = 5;
                return this.get("http".concat(this.https ? 's' : '', "://api.fast.com/netflix/speedtest?https=").concat(this.https ? 'true' : 'false', "&token=").concat(this.token, "&urlCount=").concat(this.urlCount - targets.length));

              case 5:
                _yield$this$get = _context2.sent;
                response = _yield$this$get.response;

                if (!(response.statusCode !== 200)) {
                  _context2.next = 11;
                  break;
                }

                if (!(response.statusCode === 403)) {
                  _context2.next = 10;
                  break;
                }

                throw new ApiError({
                  code: ApiError.CODES.BAD_TOKEN
                });

              case 10:
                throw new ApiError({
                  code: ApiError.CODES.UNKNOWN
                });

              case 11:
                targets.push.apply(targets, _toConsumableArray(response.data));
                _context2.next = 2;
                break;

              case 14:
                return _context2.abrupt("return", targets.map(function (target) {
                  return target.url;
                }));

              case 17:
                _context2.prev = 17;
                _context2.t0 = _context2["catch"](0);

                if (!(_context2.t0.code === 'ENOTFOUND')) {
                  _context2.next = 27;
                  break;
                }

                if (!this.https) {
                  _context2.next = 24;
                  break;
                }

                throw new ApiError({
                  code: ApiError.CODES.UNREACHABLE_HTTPS_API
                });

              case 24:
                throw new ApiError({
                  code: ApiError.CODES.UNREACHABLE_HTTP_API
                });

              case 25:
                _context2.next = 28;
                break;

              case 27:
                throw _context2.t0;

              case 28:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[0, 17]]);
      }));

      function getTargets() {
        return _getTargets.apply(this, arguments);
      }

      return getTargets;
    }()
    /**
     * Resolves when timeout or when the first video finished downloading
     *
     * @returns {Promise<number>} Speed in selected unit (Default: Bps)
     */

  }, {
    key: "getSpeed",
    value: function () {
      var _getSpeed = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        var _this2 = this;

        var targets, bytes, requestList, timer;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                targets = null;
                _context4.prev = 1;
                _context4.next = 4;
                return this.getTargets();

              case 4:
                targets = _context4.sent;
                _context4.next = 10;
                break;

              case 7:
                _context4.prev = 7;
                _context4.t0 = _context4["catch"](1);
                throw _context4.t0;

              case 10:
                bytes = 0;
                requestList = [];
                timer = new Timer(this.timeout, function () {
                  requestList.forEach(function (r) {
                    return r.abort();
                  });
                });
                targets.forEach( /*#__PURE__*/function () {
                  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(target) {
                    var _yield$_this2$get, response, request;

                    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
                      while (1) {
                        switch (_context3.prev = _context3.next) {
                          case 0:
                            _context3.next = 2;
                            return _this2.get(target);

                          case 2:
                            _yield$_this2$get = _context3.sent;
                            response = _yield$_this2$get.response;
                            request = _yield$_this2$get.request;
                            requestList.push(request);
                            response.on('data', function (data) {
                              bytes += data.length;
                            });
                            response.on('end', function () {
                              // when first video is downloaded
                              timer.stop(); // stop timer and execute timer callback
                            });

                          case 8:
                          case "end":
                            return _context3.stop();
                        }
                      }
                    }, _callee3);
                  }));

                  return function (_x2) {
                    return _ref.apply(this, arguments);
                  };
                }());
                return _context4.abrupt("return", new Promise(function (resolve) {
                  var i = 0;
                  var recents = new Array(_this2.bufferSize).fill(null); // list of most recent speeds

                  // list of most recent speeds
                  var interval = Math.min(_this2.timeout / _this2.bufferSize, MAX_CHECK_INTERVAL); // ms

                  // ms
                  var refreshIntervalId = setInterval(function () {
                    i = (i + 1) % recents.length; // loop through recents

                    // loop through recents
                    recents[i] = bytes / (interval / 1000); // add most recent bytes/second

                    // add most recent bytes/second
                    if (_this2.verbose) {
                      console.log("Current speed: ".concat(_this2.unit(_this2.constructor.average(recents)), " ").concat(_this2.unit.name));
                    }

                    bytes = 0; // reset bytes count
                  }, interval);
                  timer.addCallback(function () {
                    clearInterval(refreshIntervalId);
                    resolve(_this2.unit(_this2.constructor.average(recents)));
                  });
                  timer.start();
                }));

              case 15:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this, [[1, 7]]);
      }));

      function getSpeed() {
        return _getSpeed.apply(this, arguments);
      }

      return getSpeed;
    }()
  }], [{
    key: "average",
    value: function average(arr) {
      // remove nulls from list
      var arrWithoutNulls = arr.filter(function (e) {
        return e;
      });

      if (arrWithoutNulls.length === 0) {
        return 0;
      }

      return arrWithoutNulls.reduce(function (a, b) {
        return a + b;
      }) / arrWithoutNulls.length;
    }
  }]);

  return Api;
}();

Api.UNITS = {
  // rawSpeed is Bps
  Bps: function Bps(rawSpeed) {
    return rawSpeed;
  },
  KBps: function KBps(rawSpeed) {
    return rawSpeed / 1000;
  },
  MBps: function MBps(rawSpeed) {
    return rawSpeed / 1000000;
  },
  GBps: function GBps(rawSpeed) {
    return rawSpeed / 1000000000;
  },
  bps: function bps(rawSpeed) {
    return rawSpeed * 8;
  },
  Kbps: function Kbps(rawSpeed) {
    return rawSpeed * 8 / 1000;
  },
  Mbps: function Mbps(rawSpeed) {
    return rawSpeed * 8 / 1000000;
  },
  Gbps: function Gbps(rawSpeed) {
    return rawSpeed * 8 / 1000000000;
  }
};
module.exports = Api;